import React, { memo } from 'react';
import { ClockIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-16 md:py-24 bg-[#1e293b] border-y border-slate-800/50" data-id="element-109">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-110">
        <div className="relative p-8 md:p-12 rounded-3xl bg-slate-900/50 border border-slate-700/50 shadow-xl" data-id="element-111">
          <ClockIcon className="absolute top-8 left-8 w-8 h-8 text-teal-500 opacity-50" data-id="element-112" />

          <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed pt-8" data-id="element-113">
            <p className="font-medium text-white" data-id="element-114">
              Son las 11:00 PM. Estás de pie en la cocina, mirando un plato que
              olvidaste lavar hace 12 horas. Tu pareja entra, lo ve y el
              silencio se vuelve pesado.
            </p>

            <p data-id="element-115">
              Sabes lo que viene: una discusión de dos horas que terminará en
              lágrimas, cansancio y la frase que más duele:{' '}
              <span className="text-amber-400 italic" data-id="element-116">
                "Siento que no te importa nada"
              </span>
              .
            </p>

            <p data-id="element-117">
              Pero la verdad es que SÍ te importa. El problema no es tu falta de
              amor, es una falla de hardware en tu memoria operativa.
            </p>

            <p className="text-teal-100 font-medium" data-id="element-118">
              Estás intentando usar herramientas lineales en un cerebro que
              funciona por ráfagas de dopamina y estímulos visuales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}